import {
  ALLMENU
} from '../Constants'

export const GET_TOKEN = 'GET_TOKEN'

export const updateAllMenu = (allMenu) => {
  return {
    type: "SET_ALLMENU",
    payload: {
      allMenu
    }
  }
}
export const updateMenuSub = (menuSub) => {
  return {
    type: "SET_MENU_SUB",
    payload: {
      menuSub
    }
  }
}

export const updateMenuSubList = (menuSubList) => {
  return {
    type: "SET_MENU_SUBLIST",
    payload: {
      menuSubList
    }
  }
}

export const updateMenuCard = (menuCard) => {
  return {
    type: "SET_MENU_CARD",
    payload: {
      menuCard
    }
  }
}

export const updateMenuSubCard = (menuSubCard) => {
  return {
    type: "SET_MENU_SUB_CARD",
    payload: {
      menuSubCard
    }
  }
}

export const restoreAllMenu = () => {
  const allMenu = JSON.parse(localStorage.getItem(ALLMENU))

  return {
    type: "SET_ALLMENU",
    payload: {
      allMenu
    }
  }
}

